import { heureka } from "@otto-ec/heureka";
import { dereference } from "../tracking/FeatureTracking";
import { fireFilterSubmit } from "./FilterFormActions";

export function registerFilterSectionChangedListener() {
  heureka.filterSection_change.on((event) => {
    const referenced = dereference(event.target);
    if (referenced && referenced instanceof HTMLInputElement) {
      referenced.checked = event.target.checked;
      fireFilterSubmit(referenced);
    }
  });
}
